<template>
  <van-popup v-model="visible" round position="center" :close-on-click-overlay="true" @close="handleClose">
    <div class="bind-upline-dialog">
      <div class="dialog-title">{{ $t('lang.Invite.k102') }}</div>
      <div class="input-wrap">
        <input
          v-model="inviteCode"
          class="invite-input"
          type="text"
          maxlength="30"
          :placeholder="$t('lang.Invite.k136')"
          @input="handleInput"
        />
        <button v-if="inviteCode" type="button" class="clear-btn" @click="handleClear">
          <span class="clear-icon">×</span>
        </button>
      </div>
      <button type="button" class="bind-btn" :class="{ active: canSubmit }" :disabled="!canSubmit || loading" @click="handleSubmit">
        {{ $t('lang.BaseCommon.k004') }}
      </button>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'BindUplineAgentDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      inviteCode: '',
    }
  },
  computed: {
    visible: {
      get() {
        return this.show
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      },
    },
    canSubmit() {
      return !!(this.inviteCode || '').trim()
    },
  },
  watch: {
    show(val) {
      if (!val) {
        this.inviteCode = ''
      }
    },
  },
  methods: {
    handleInput() {
      this.inviteCode = (this.inviteCode || '').replace(/\s/g, '')
    },
    handleClear() {
      this.inviteCode = ''
    },
    handleClose() {
      this.$emit('close')
    },
    handleSubmit() {
      const code = (this.inviteCode || '').trim()
      if (!code || this.loading) return
      this.$emit('confirm', code)
    },
  },
}
</script>

<style lang="scss" scoped>
.bind-upline-dialog {
  width: 311px;
  padding: 16px 12px;
  background: #ffffff;
  border-radius: 16px;
  box-sizing: border-box;

  .dialog-title {
    font-family: var(--string-font);
    font-weight: var(--fw-400);
    font-size: var(--fs-20);
    line-height: 28px;
    color: #333333;
    text-align: center;
  }

  .input-wrap {
    display: flex;
    align-items: center;
    margin-top: 16px;
    padding: 0 12px;
    min-height: 52px;
    background: #f9f9f9;
    border-radius: 12px;

    > * + * {
      margin-left: 16px;
    }
  }

  .invite-input {
    flex: 1;
    min-width: 0;
    border: none;
    background: transparent;
    font-family: var(--string-font);
    font-weight: var(--fw-400);
    font-size: var(--fs-14);
    line-height: var(--lh-title-20);
    color: #333333;
    outline: none;

    &::placeholder {
      color: #cccccc;
    }
  }

  .clear-btn {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.75);
    cursor: pointer;
  }

  .clear-icon {
    font-size: 12px;
    line-height: 1;
    color: #ffffff;
  }

  .bind-btn {
    width: 100%;
    min-height: 52px;
    margin-top: 16px;
    padding: 6px 24px;
    border: 1px solid #e6e5e7;
    border-radius: 12px;
    background: #ffffff;
    font-family: var(--string-font);
    font-weight: var(--fw-400);
    font-size: var(--fs-14);
    line-height: var(--lh-title-20);
    color: #666666;

    &.active {
      border-color: #f8e5bd;
      background: #f8e5bd;
      color: #925e0d;
    }

    &:disabled {
      opacity: 1;
    }
  }
}
</style>
<style lang="scss">
html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .bind-upline-dialog {
    .input-wrap {
      > * + * {
        margin-left: 0;
        margin-right: 16px;
      }
    }
  }
}
</style>
